import React from "react";
import _ from 'lodash';
import Loader from "../loader";
import AsianGameEvent from "../asianGameEvent";
import { Link } from "react-router";
import { getAsianMarketTypes } from '../../../helpers/asianHelpers';
import Config from '../../../config/main';
import { t } from "../../../helpers/translator";
import Scores from '../asianScores';
import { PartnerStreamsContext } from "../../../contexts/partnerStreams";
import BetBuilderIcon from "../../containers/betBuilderWrapper/components/betBuilderIcon";

export default function asianGameTemplate() {
    const { game, gameType, sportAlias, gameArray, gameMarketData, cursor, gameId, boostedOddsGameIds, pathname } = this.props,
        { openFilters, filter } = this.state,
        MarketTypes = getAsianMarketTypes(gameType, sportAlias);

    const [marketArray] = this.context;
    const markets = MarketTypes.map((array, index) => array[marketArray[index]]);

    if (!game) return <Loader />;

    return (
        <ul className={`a-single-game-row ${Config.enablePeriodScore ? Config.enablePeriodScore && gameType === "live" ? " score-show" : "" : ""} ${gameId === gameArray[cursor] ? 'active' : ''}`} key={game.id + markets.reduce((sum, current) => sum + current.title, '')}>
            {
                Config.main.enableAppearGame
                    ? <li key={game.id}>
                        <div className={`a-name-column-v ${Config.enablePeriodScore ? Config.enablePeriodScore && gameType === "live" ? " four-market" : "" : ""}`}>
                            {
                                game.markets_count && game.marketGroups.length !== 0 ? (<div className={`dropdown-view-w-t ${openFilters ? "active" : ""}`} ref={this.dropdownElementRef} onClick={this.openFilters}>
                                    <p>{t(filter)}</p>
                                    <div className="open-d-w-t">
                                        <ul>
                                            {
                                                game.marketGroups.map((type, index) => <li value={type} key={index} className={filter.includes(type)
                                                    ? "active" : ""} onClick={this.selectFilter(type)}>{t(type)}</li>)
                                            }
                                        </ul>
                                    </div>
                                </div>) : ''
                            }
                            <div className="team-info-block-t">
                                {
                                    Config.main.enableAppearGame ? (
                                        <div className={`team-name-info-t`} onClick={() => this.props.toggleGameEventsInList(true, game.id)}>
                                            <p className="a-team-name-v">
                                                <span>{game.team1_name}</span>
                                                {game.type === 1 && game.info && game.info.score1 && !Config.enablePeriodScore ? <b><i className="score-v">{game.info.score1}</i></b> : null}

                                            </p>
                                            <p className="a-team-name-v">
                                                <span>{game.team2_name}</span>
                                                {game.type === 1 && game.info && game.info.score1 && !Config.enablePeriodScore ? <b><i className="score-v">{game.info.score2}</i></b> : null}
                                            </p>
                                        </div>
                                    ) : (
                                        <Link onClick={() => {
                                            sessionStorage.setItem('scrollPos', JSON.stringify({ [history.state.key]: document.getElementById('getScrollPosition').scrollTop }));
                                        }} to={`/${gameType}/${sportAlias}/${game.regionId}/${game.competitionId}/${game.id}`} className="team-name-info-t">
                                            <p className="a-team-name-v active">
                                                <span>{game.team1_name}</span>
                                            </p>
                                            <p className="a-team-name-v">
                                                <span>{game.team2_name}</span>
                                            </p>
                                        </Link>
                                    )
                                }
                                {
                                    Config.enablePeriodScore && gameType === 'live' &&
                                    <Scores sportAlias={sportAlias}
                                        game={game}
                                    />
                                }
                            </div>
                            {
                                Config.showGameNumber && game.game_number ? <p className="a-team-name-v game-id">GAME ID: {game.game_number}</p> : null
                            }
                            {
                                this.setDateByGameType(game, gameType)
                            }
                        </div>
                    </li>
                    : <li>
                        <div className={`a-name-column-v ${Config.enablePeriodScore ? Config.enablePeriodScore && gameType === "live" ? "four-market" : "" : ""}`}>
                            {
                                game.markets_count && game.marketGroups.length !== 0 ? (<div className={`dropdown-view-w-t ${openFilters ? "active" : ""}`} onClick={this.openFilters} ref={this.dropdownElementRef}>
                                    <p>{t(filter)}</p>
                                    <div className="open-d-w-t">
                                        <ul>
                                            {
                                                game.marketGroups.map((type, index) => <li value={type} key={index} className={filter === type
                                                    ? "active" : ""} onClick={this.selectFilter(type)}>{t(type)}</li>)
                                            }
                                        </ul>
                                    </div>
                                </div>) : ''
                            }
                            {
                                Config.main.enabelFromGameToMarkets ? <Link onClick={() => {
                                    sessionStorage.setItem('scrollPos', JSON.stringify({ [history.state.key]: document.getElementById('getScrollPosition').scrollTop }));
                                }} to={`/${gameType}/${sportAlias}/${game.regionId}/${game.competitionId}/${game.id}`} >
                                    <p className="a-team-name-v">
                                        <span>{game.team1_name}</span>
                                        {game.type === 1 && game.info?.score1 && !Config.enablePeriodScore ? <b><i className="score-v">{game.info.score1}</i></b> : null}
                                    </p>
                                    <p className="a-team-name-v">
                                        <span>{game.team2_name}</span>
                                        {game.type === 1 && game.info?.score1 && !Config.enablePeriodScore ? <b><i className="score-v">{game.info.score2}</i></b> : null}
                                    </p>
                                </Link>
                                    : <>
                                        <p className="a-team-name-v">
                                            <span>{game.team1_name}</span>
                                            {game.type === 1 && game.info?.score1 && !Config.enablePeriodScore ? <b><i className="score-v">{game.info.score1}</i></b> : null}
                                        </p>
                                        <p className="a-team-name-v">
                                            <span>{game.team2_name}</span>
                                            {game.type === 1 && game.info?.score1 && !Config.enablePeriodScore ? <b><i className="score-v">{game.info.score2}</i></b> : null}
                                        </p>
                                    </>
                            }
                            {
                                Config.enablePeriodScore && gameType === 'live' &&
                                <Scores sportAlias={sportAlias}
                                    game={game}
                                />
                            }
                            {
                                Config.showGameNumber && game.game_number ? <p className="a-team-name-v game-id">GAME ID: {game.game_number}</p> : null
                            }
                            {
                                this.setDateByGameType(game, gameType)
                            }
                            {
                                Config.enableUpcomingLiveGamesInPrematch && game.type === 2 && <i className='is-going-to-be-live'></i>
                            }
                        </div>
                    </li>
            }
            {(function () {
                const temp = [];
                if (Config.sportListThatCanBeBoostedOdds.includes(game.alias)) {
                    const boostedGameIds = Config.enableBoostedOdds && Object.keys(boostedOddsGameIds).includes(game.id.toString()) && boostedOddsGameIds[game.id];
                    var boostedGameMarketsObject = boostedGameIds && createDynamicObjectFromGameMarketsArray(boostedGameIds);
                }
                if (pathname.includes("boosted") && boostedOddsGameIds[game.id]) {
                    var boostedGameMarketsObject = boostedOddsGameIds[game.id] ? createDynamicObjectFromGameMarketsArray(boostedOddsGameIds[game.id]) : false;
                }

                game.markets_count ? markets.forEach((item, i) => {
                    return item.side.forEach(sideItem => {
                        temp.push(<AsianGameEvent key={'' + sideItem + item.title} item={{
                            ...item, side: sideItem
                        }} game={game} group={filter} boostedOdds={boostedGameMarketsObject} />);
                    });
                }) : temp.push((<li key={'canNotbetNow'} className='canNotbetNow' >{t("You can not bet now.")}</li>));
                return temp;
            }())
            }
            <li className="market-v-s-icons">
                <PartnerStreamsContext.Consumer>
                    {streamsData => !!streamsData.stream_configs?.[game.id]?.[0] && <div onClick={() => this.upperScreenStreem(streamsData.stream_configs[game.id][0])} className="video-channel-v">{game.tv_type}</div>}
                </PartnerStreamsContext.Consumer>
                <div className="actions-container">
                    <BetBuilderIcon game={game} />
                    {Config.statisticsButton &&
                        this.props.game.is_stat_available
                        ? <div className="statictic-button-c" onClick={() => { this.upperScreenStatistics(game); }}>
                        </div>
                        : null}
                </div>
                <div className="markets-count-view-m">
                    {
                        Config.main.enableAppearGame ? (
                            <span onClick={() => {
                                this.props.toggleGameEventsInList(true, game.id);
                            }} className="link-view-home-slider">
                                {"+" + gameMarketData?.market}
                            </span>
                        ) : (
                            <Link onClick={() => {
                                sessionStorage.setItem('scrollPos', JSON.stringify({ [history.state.key]: document.getElementById('getScrollPosition').scrollTop }));
                            }} className="link-view-home-slider" to={`/${gameType}/${sportAlias}/${game.regionId}/${game.competitionId}/${game.id}`} >
                                {"+" + gameMarketData?.market}
                            </Link>
                        )
                    }
                </div>
            </li>
        </ul>
    )
}

function createDynamicObjectFromGameMarketsArray(array) {
    let newObject = {};
    if (array) {
        for (let item of array) {
            var tempObj = {
                ...tempObj,
                [item.Id]: {
                    Id: item.Id,
                    marketId: item.MarketId,
                    name: item.Name,
                    marketName: item.MarketName,
                    MatchId: item.MatchId
                }
            };
            newObject = tempObj;
        }
    }
    return newObject;
}